import { render, staticRenderFns } from "./RegisterStep2.vue?vue&type=template&id=6c11a110&scoped=true"
import script from "./RegisterStep2.vue?vue&type=script&lang=js"
export * from "./RegisterStep2.vue?vue&type=script&lang=js"
import style0 from "./RegisterStep2.vue?vue&type=style&index=0&id=6c11a110&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c11a110",
  null
  
)

export default component.exports